import { doesPayloadRequireSigning } from '@standardnotes/encryption/src/Domain/Operator/004/V004AlgorithmHelpers';
import { PayloadSource, PublicKeyTrustStatus } from '@standardnotes/models';
import { ItemSignatureValidationResult } from './Types/ItemSignatureValidationResult';
export class ValidateItemSigner {
    constructor(findContact) {
        this.findContact = findContact;
    }
    execute(item) {
        const uuidOfLastEditor = item.last_edited_by_uuid;
        if (uuidOfLastEditor) {
            return this.validateSignatureWithLastEditedByUuid(item, uuidOfLastEditor);
        }
        else {
            return this.validateSignatureWithNoLastEditedByUuid(item);
        }
    }
    isItemLocallyCreatedAndDoesNotRequireSignature(item) {
        return item.payload.source === PayloadSource.Constructor;
    }
    isItemResutOfRemoteSaveAndDoesNotRequireSignature(item) {
        return item.payload.source === PayloadSource.RemoteSaved;
    }
    validateSignatureWithLastEditedByUuid(item, uuidOfLastEditor) {
        const requiresSignature = doesPayloadRequireSigning(item);
        const trustedContact = this.findContact.execute({ userUuid: uuidOfLastEditor });
        if (trustedContact.isFailed()) {
            if (requiresSignature) {
                return ItemSignatureValidationResult.NotTrusted;
            }
            else {
                return ItemSignatureValidationResult.NotApplicable;
            }
        }
        if (!item.signatureData) {
            if (this.isItemLocallyCreatedAndDoesNotRequireSignature(item) ||
                this.isItemResutOfRemoteSaveAndDoesNotRequireSignature(item)) {
                return ItemSignatureValidationResult.NotApplicable;
            }
            if (requiresSignature) {
                return ItemSignatureValidationResult.NotTrusted;
            }
            return ItemSignatureValidationResult.NotApplicable;
        }
        const signatureData = item.signatureData;
        if (!signatureData.result) {
            if (signatureData.required) {
                return ItemSignatureValidationResult.NotTrusted;
            }
            return ItemSignatureValidationResult.NotApplicable;
        }
        const signatureResult = signatureData.result;
        if (!signatureResult.passes) {
            return ItemSignatureValidationResult.NotTrusted;
        }
        const signerPublicKey = signatureResult.publicKey;
        const trustStatus = trustedContact.getValue().getTrustStatusForSigningPublicKey(signerPublicKey);
        if (trustStatus === PublicKeyTrustStatus.Trusted) {
            return ItemSignatureValidationResult.Trusted;
        }
        else if (trustStatus === PublicKeyTrustStatus.Previous) {
            return ItemSignatureValidationResult.SignedWithNonCurrentKey;
        }
        return ItemSignatureValidationResult.NotTrusted;
    }
    validateSignatureWithNoLastEditedByUuid(item) {
        const requiresSignature = doesPayloadRequireSigning(item);
        if (!item.signatureData) {
            if (this.isItemLocallyCreatedAndDoesNotRequireSignature(item) ||
                this.isItemResutOfRemoteSaveAndDoesNotRequireSignature(item)) {
                return ItemSignatureValidationResult.NotApplicable;
            }
            if (requiresSignature) {
                return ItemSignatureValidationResult.NotTrusted;
            }
            return ItemSignatureValidationResult.NotApplicable;
        }
        const signatureData = item.signatureData;
        if (!signatureData.result) {
            if (signatureData.required) {
                return ItemSignatureValidationResult.NotTrusted;
            }
            return ItemSignatureValidationResult.NotApplicable;
        }
        const signatureResult = signatureData.result;
        if (!signatureResult.passes) {
            return ItemSignatureValidationResult.NotTrusted;
        }
        const signerPublicKey = signatureResult.publicKey;
        const trustedContact = this.findContact.execute({ signingPublicKey: signerPublicKey });
        if (trustedContact.isFailed()) {
            return ItemSignatureValidationResult.NotTrusted;
        }
        const trustStatus = trustedContact.getValue().getTrustStatusForSigningPublicKey(signerPublicKey);
        if (trustStatus === PublicKeyTrustStatus.Trusted) {
            return ItemSignatureValidationResult.Trusted;
        }
        else if (trustStatus === PublicKeyTrustStatus.Previous) {
            return ItemSignatureValidationResult.SignedWithNonCurrentKey;
        }
        return ItemSignatureValidationResult.NotTrusted;
    }
}
